export const Kkconfig = {
  // ========== container ==========
  reqUrl: {
    dynApiUrl: document.querySelector('body').getAttribute('dau'),
    stApiUrl: document.querySelector('body').getAttribute('sau'),
    payUrl: document.querySelector('body').getAttribute('dau'),
    imgUrl: document.querySelector('body').getAttribute('igu'),
    imUrl: document.querySelector('body').getAttribute('imu')
  }
  // ========== local ==========
  // reqUrl: {
  //   dynApiUrl: 'http://localhost:8070',
  //   stApiUrl: 'http://localhost:8070',
  //   payUrl: 'http://localhost:8070',
  //   imgUrl: 'http://img-app.kwcff.com',
  //   imUrl: 'about:blank'
  // }
  // ========== test ==========
  // reqUrl: {
  //   dynApiUrl: 'http://api.ccnesk.com',
  //   stApiUrl: 'http://api.ccnesk.com',
  //   payUrl: 'http://api.ccnesk.com',
  //   imgUrl: 'http://img-app.ccnesk.com',
  //   imUrl: 'about:blank'
  // }
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js